/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Checkboxes_Coderedemptiononly2Inputs */

const id_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanya Penukaran Kode`)
};

const ms_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penebusan Kod Sahaja`)
};

const da_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kun Kodeindløsning`)
};

const de_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur Code-Einlösung`)
};

const en_us2_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code Redemption Only`)
};

const es_es2_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo canje de código`)
};

const es_mx2_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo canje de código`)
};

const fil_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code Redemption Lang`)
};

const fr_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sur code uniquement`)
};

const it_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo riscatto codice`)
};

const hu_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Csak kód beváltás`)
};

const nl_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alleen code-inwisseling`)
};

const no_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kun kodeinnløsning`)
};

const pl_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tylko aktywacja kodem`)
};

const pt_br2_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Somente resgate de código`)
};

const pt_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apenas resgate de código`)
};

const ro_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doar răscumpărare cod`)
};

const fi_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vain koodin lunastus`)
};

const sv_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endast kod-inlösen`)
};

const vi_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ đổi mã`)
};

const tr_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yalnızca Kod Kullanımı`)
};

const cs_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pouze uplatnění kódu`)
};

const bg_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Само с код`)
};

const ru_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Только активация кода`)
};

const uk_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лише активація коду`)
};

const ar_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استلام رمز فقط`)
};

const hi_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केवल कोड रिडेम्पशन`)
};

const th_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ใช้โค้ดเท่านั้น`)
};

const ja_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コード引き換えのみ`)
};

const zh_cn2_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仅限兑换码`)
};

const zh_hant1_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`僅限兌換碼`)
};

const ko_search_checkboxes_coderedemptiononly2 = /** @type {(inputs: Search_Checkboxes_Coderedemptiononly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`코드 교환 전용`)
};

/**
* | output |
* | --- |
* | "Code Redemption Only" |
*
* @param {Search_Checkboxes_Coderedemptiononly2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_checkboxes_coderedemptiononly2 = /** @type {((inputs?: Search_Checkboxes_Coderedemptiononly2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Checkboxes_Coderedemptiononly2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_checkboxes_coderedemptiononly2(inputs)
	if (locale === "ms") return ms_search_checkboxes_coderedemptiononly2(inputs)
	if (locale === "da") return da_search_checkboxes_coderedemptiononly2(inputs)
	if (locale === "de") return de_search_checkboxes_coderedemptiononly2(inputs)
	if (locale === "en-US") return en_us2_search_checkboxes_coderedemptiononly2(inputs)
	if (locale === "es-ES") return es_es2_search_checkboxes_coderedemptiononly2(inputs)
	if (locale === "es-MX") return es_mx2_search_checkboxes_coderedemptiononly2(inputs)
	if (locale === "fil") return fil_search_checkboxes_coderedemptiononly2(inputs)
	if (locale === "fr") return fr_search_checkboxes_coderedemptiononly2(inputs)
	if (locale === "it") return it_search_checkboxes_coderedemptiononly2(inputs)
	if (locale === "hu") return hu_search_checkboxes_coderedemptiononly2(inputs)
	if (locale === "nl") return nl_search_checkboxes_coderedemptiononly2(inputs)
	if (locale === "no") return no_search_checkboxes_coderedemptiononly2(inputs)
	if (locale === "pl") return pl_search_checkboxes_coderedemptiononly2(inputs)
	if (locale === "pt-BR") return pt_br2_search_checkboxes_coderedemptiononly2(inputs)
	if (locale === "pt") return pt_search_checkboxes_coderedemptiononly2(inputs)
	if (locale === "ro") return ro_search_checkboxes_coderedemptiononly2(inputs)
	if (locale === "fi") return fi_search_checkboxes_coderedemptiononly2(inputs)
	if (locale === "sv") return sv_search_checkboxes_coderedemptiononly2(inputs)
	if (locale === "vi") return vi_search_checkboxes_coderedemptiononly2(inputs)
	if (locale === "tr") return tr_search_checkboxes_coderedemptiononly2(inputs)
	if (locale === "cs") return cs_search_checkboxes_coderedemptiononly2(inputs)
	if (locale === "bg") return bg_search_checkboxes_coderedemptiononly2(inputs)
	if (locale === "ru") return ru_search_checkboxes_coderedemptiononly2(inputs)
	if (locale === "uk") return uk_search_checkboxes_coderedemptiononly2(inputs)
	if (locale === "ar") return ar_search_checkboxes_coderedemptiononly2(inputs)
	if (locale === "hi") return hi_search_checkboxes_coderedemptiononly2(inputs)
	if (locale === "th") return th_search_checkboxes_coderedemptiononly2(inputs)
	if (locale === "ja") return ja_search_checkboxes_coderedemptiononly2(inputs)
	if (locale === "zh-CN") return zh_cn2_search_checkboxes_coderedemptiononly2(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_checkboxes_coderedemptiononly2(inputs)
	return ko_search_checkboxes_coderedemptiononly2(inputs)
});
export { search_checkboxes_coderedemptiononly2 as "search.checkboxes.codeRedemptionOnly" }